import { useConnect } from '@lore/query-connect';
import { useUser } from '@lore/auth';

export default function useActiveProjects() {
  const currentUser = useUser();

  return useConnect('project.find', {
    where: {
      filter: { active: true, creatorId: currentUser.id }
    },
    pagination: {
      pageSize: 100,
      order: 'createdAt desc',
    }
  });
}
